module.exports = __webpack_public_path__ + "static/img/t59.4ee45bdd.png";